export default {
  unitLabel: {
    carbonNitrogen: 'Carbon / Nitrogen',
    thickness: 'Thickness',
  },
};
